<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.5 4L3.96447 7.53553L7.5 11.0711" stroke="currentColor" stroke-linecap="round"/>
<path d="M11.5 4L7.96447 7.53553L11.5 11.0711" stroke="currentColor" stroke-linecap="round"/>
</svg>
